export default __webpack_public_path__ + "static/media/Slough.528e9659.jpg";